/**
 * Created by Dong on 2017/7/21.
 */
import './style.scss'
import React, { Component } from 'react'
import {  LossKandySessionAction } from '../../components'
import { actions as kandyActions } from 'kandy-redux'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
    serviceRequestActions,
    chatActions,
    videoActions,
    agentActions,
    dashboardActions,
    sessionTransferActions,
    currentCallActions
} from '../../../actions'
import {
    serviceRequestPiccActions,
    screenShotActions,
    reportPreviewActions,
    wxSmallProgramRequestAction
} from '../../actions'
import callingImage from '../../../assets/images/calling.png'
import video_hang from '../../../assets/images/workBench/video_hang.png'
import vioce_hang from '../../../assets/images/workBench/vioce_hang.png'
/**
 * Session container.
 * Handles the active session
 * i.e. currently going on chats and calls with the customer
 */
class KandySession extends Component {
    constructor(props) {
        super(props)
        this.state = {}


    }

    componentDidUpdate() {

    }


    render() {
        const { dashboard, actions, calls, chatError, chatMessages, currentAgent, customer,  isWithCall, cannedMessages, video, serviceReqStatus, serviceRequests, company,  userCustomer, departments, currentReport, callStats,
            wxSmallProgramRequest } = this.props
        let chatActionsDiv;
        let call = null;
        let chatShadeView = null;
        let chatBox;

        if (currentAgent && currentAgent.fullUserId && customer && customer.userId) {
            call = calls.filter((v) => {
                return (v.callerFullUserId == currentAgent.fullUserId && v.calleeFullUserId == customer.userId) ||
                    (v.calleeFullUserId == currentAgent.fullUserId && v.callerFullUserId == customer.userId)
            })[0]
        }
        if (customer && customer.isShowShadeView == true && customer.type == 'voice') {
            chatShadeView = (
                <div >
                    <div className="session_bgshow-picc"></div>
                    <div className="session-bg-picc">
                        <img className="session-img" src={vioce_hang} />
                    </div>
                </div>
            )
        }
        else if (customer && customer.isShowShadeView == true && customer.type == 'video') {
            chatShadeView = (
                <div >
                    <div className="session_bgshow-picc"></div>
                    <div className="session-bg-picc">
                        <img className="session-img" src={video_hang} />
                    </div>
                </div>
            )
        } else if (customer.channelType == 'wxSmallProgram' &&
            wxSmallProgramRequest && !wxSmallProgramRequest.getFetchLivePlayResult &&
            wxSmallProgramRequest.getImLoginInfoResult) {
            //{!wxSmallProgramRequest.getImLoginInfoResult ? 'session_bgshow-picc' : 'session_bgshow-picc wxProgram-div-bg1'}
            chatShadeView = (
                <div>
                    <div className='session_bgshow-picc'></div>
                    <div className="session-bg-picc">
                        <img className="session-img" src={video_hang} />
                    </div>
                </div>
            )
        }
        if (!customer.didSessionEnd && !customer.endedAt) {
            chatActionsDiv = (
                <div className="loss-session-footer">
                    <LossKandySessionAction
                        actions={actions}
                        call={call}
                        video={video}
                        chatError={chatError}
                        currentAgent={currentAgent}
                        customer={customer}
                        isWithCall={isWithCall}
                        serviceReqStatus={serviceReqStatus}
                        serviceRequests={serviceRequests}
                        company={company}
                        currentReport={currentReport}
                        currentCallCount={calls.length}
                        callStats={callStats}
                        wxSmallProgramRequest={wxSmallProgramRequest}
                    />

                </div>
            )
        }
        return (
            <div className="session-css">
                {chatShadeView}
                {!customer.isSessionActive ?
                    <div style={{ marginTop: '25%', textAlign: 'center' }}>
                        <img className="" src={callingImage} />
                        <div style={{ marginTop: 20 }}>等待视频接通中...</div>
                    </div> : ''}
                {chatActionsDiv}
            </div>
        )
    }

}

/**
 * Props that Session component expects to be passed.
 *   Session component only needs to be provided
 *   with the remote user information. It retreives
 *   all else from state based on this user.
 */
/*KandySession.propTypes = {
 // Information related to the connected customer.
 customer: PropTypes.shape({
 userId: PropTypes.string,
 isSessionActive: PropTypes.bool
 }).isRequired
 };*/

let mapStateToProps = (state, props) => {
    return {
        // Array of call objects.
        calls: state.app.kandy.calls,
        // Array of chat messages from past sessions.
        // Array of chat messages from the current session.
        // Chat error object
        chatError: state.app.notices.chatError,
        // Details of the logged-in agent (current user).
        currentAgent: state.app.currentAgent.userInfo,
        // Canned Messages from the Agent
        cannedMessages: state.app.cannedMessages.list,
        // Size of the remote video container.
        video: state.app.video,
        company: state.company,
        departments: state.app.departments.list,
        dashboard: state.app.dashboard,
        currentReport: state.lossAss.reportPreview.currentPreviewReport,
        wxSmallProgramRequest: state.lossAss.wxSmallProgramRequest
    }
};

let mapDispatchToProps = (dispatch) => {
    // Group the session related actions together.
    let actions = Object.assign({},
        kandyActions,
        serviceRequestActions,
        chatActions,
        videoActions,
        agentActions,
        dashboardActions,
        sessionTransferActions,
        serviceRequestPiccActions,
        screenShotActions,
        reportPreviewActions,
        wxSmallProgramRequestAction,
        currentCallActions
    );

    return {
        actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(KandySession)
